



































import { Component } from 'vue-property-decorator'

import FoldingCard from '@/components/FoldingCard.vue'
import detail from '@/modules/Policy/views/detail.vue'

@Component({
  components: {
    FoldingCard
  }
})
export default class PolicyDetailSource extends detail {
  routeToProducerDetail () {
    return {
      name: 'ProducerDetailDetail',
      params: {
        id: this.policy.source.id + ''
      }
    }
  }

  routeToBookDetail () {
    return {
      name: 'BookDetailDetail',
      params: {
        id: this.policy.book.id + ''
      }
    }
  }
}
